import { PuntoPeligroApi } from '@/domain/entities/Api'
import { Commit } from '@/store/types'
import { getEnvironments } from '@/environments'
import { client as fetch } from './ClientService'

export interface PuntosPeligroInterface {
  getPuntoPeligro(): Promise<Commit<PuntoPeligroApi>>
}

export class PuntosPeligroService implements PuntosPeligroInterface {
  env = getEnvironments()
  apiUrl: string = this.env.url.API ? this.env.url.API : window.location.origin
  constructor (apiUrl?: string) {
    this.apiUrl = apiUrl || this.apiUrl
  }
  async getPuntoPeligro (): Promise<Commit<PuntoPeligroApi>> {
    try {
      const response = await fetch(`${this.apiUrl}/api/puntos-peligro`)
      return { type: 'PUNTO_PELIGRO_FETCHED', payload: response }
    } catch (e) {
      return { type: 'PUNTO_PELIGRO_ERROR', payload: e }
    }
  }
}
